import WidgetOptions from "../WidgetOptions";
import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

const StickyNoteWidget =
    ({
         widgetDisplayName = "",
         text = "",
         bgColorClass = "",
         customStyle = {},
         isEditMode = false,
         isDashboardFullScreen = false,
         onEditClick = () => { },
         onForceUpdateClick = () => { },
         onDuplicateClicked = () => { },
         onDeleteClicked = () => { },
     }) => {
        return (
            <div className={classnames("widget p-total-0", bgColorClass)} style={{overflowY: "overlay"}}>
                <div className="row">
                    <div className="col-lg-12 wordBreak">
                        <div className="controller-vertical-container controller-element-3" style={customStyle}>
                            <WidgetOptions
                                isEditMode={isEditMode}
                                className="widget-options-contained widget-options-effect pd-r-15"
                                onEditClicked={onEditClick}
                                isDashboardFullScreen={isDashboardFullScreen}
                                onRefreshClicked={onForceUpdateClick}
                                onDuplicateClicked={onDuplicateClicked}
                                onDeleteClicked={onDeleteClicked}
                            />
                            <span className="controller-element controller-text-align controller-element-1 stickyNote-title"><b>{widgetDisplayName}</b></span>
                            <span className="controller-text-align controller-element-2 mb-15 m-r-25 stickyNote-text">{text}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

StickyNoteWidget.propTypes = {
    text: PropTypes.string,
    customStyle: PropTypes.object,
    bgColorClass: PropTypes.string,
    widgetDisplayName:  PropTypes.string.isRequired,
    isEditMode: PropTypes.bool,
    isDashboardFullScreen: PropTypes.bool,
    onRefreshClicked: PropTypes.func,
    onForceUpdateClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func,
    onDeleteClicked: PropTypes.func
};

export default StickyNoteWidget;